import { Check, LockKeyhole, Play, Search } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { useMediaQuery } from "../hooks/useMediaQuery";

const nodes = [
  { x: 72, y: 190, label: "触发", sublabel: "CI / HTTP", icon: Play },
  { x: 210, y: 128, label: "校验", sublabel: "ENV", icon: Search },
  { x: 348, y: 166, label: "证据", sublabel: "TRACE / ALLURE", icon: Check },
  { x: 492, y: 82, label: "门禁", sublabel: "PASS ONLY", icon: LockKeyhole },
] as const;

export function SignalDiagram() {
  const reduceMotion = useReducedMotion();
  const isPhone = useMediaQuery("(max-width: 767px)");

  return (
    <div
      className="signal-diagram"
      role="img"
      aria-label="质量信号链路：触发、环境校验、证据归档、明确通过后继续发布"
    >
      <div className="signal-diagram__header">
        <span>QUALITY SIGNAL</span>
        <span className="signal-diagram__status">
          <i aria-hidden="true" /> 可审计路径
        </span>
      </div>
      <svg viewBox="0 0 560 260" aria-hidden="true" focusable="false">
        <path className="signal-grid" d="M0 40H560M0 100H560M0 160H560M0 220H560M70 0V260M210 0V260M350 0V260M490 0V260" />
        <motion.path
          className="signal-route"
          d="M55 214 C105 214 106 155 145 155 S185 93 222 112 S280 178 320 145 S394 114 430 76 S488 61 526 40"
          initial={reduceMotion || isPhone ? false : { pathLength: 0, opacity: 0.4 }}
          whileInView={reduceMotion || isPhone ? undefined : { pathLength: 1, opacity: 1 }}
          viewport={reduceMotion || isPhone ? undefined : { once: true, amount: 0.4 }}
          transition={{ duration: isPhone ? 0.65 : 1.4, ease: [0.22, 1, 0.36, 1] }}
        />
        {nodes.map(({ x, y, label, sublabel, icon: Icon }) => (
          <g key={label} transform={`translate(${x} ${y})`}>
            <circle className="signal-node" r="7" />
            <circle className="signal-node-halo" r="13" />
            <foreignObject x="-52" y="-52" width="104" height="38">
              <div className="signal-node-label">
                <Icon size={13} strokeWidth={2.2} aria-hidden="true" />
                <strong>{label}</strong>
                <small>{sublabel}</small>
              </div>
            </foreignObject>
          </g>
        ))}
      </svg>
      <div className="signal-seal" aria-hidden="true">
        <strong>CM</strong>
        <span>QA / DEV</span>
        <small>5Y+</small>
      </div>
      <div className="signal-diagram__footer">
        <span>自动执行</span>
        <span>失败可追溯</span>
        <span>结果可轮询</span>
      </div>
    </div>
  );
}
